








import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {
    Search: () => import('./components/search.vue'),
    List: () => import('./components/list.vue')
  }
})
export default class Materials extends Vue {}
